export default {
    required: 'Pole model jest wymagane',
    pattern: {
        value: /.{1,}/,
        message: 'Wybierz poprawny model z listy'
    }
}